<script setup lang="ts">
import BaseMenuBarMobile from '@/components/base/BaseMenuBarMobile.vue';
import BaseIcon from '@/components/base/baseIcon.vue'
import { pageNames } from '@/enums/pageNames';
import { iconNames } from '@/enums/iconNames'
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { userProfileStore } from '@/stores/user/userProfile';

const route = useRoute()
const router = useRouter()
const userProfile = userProfileStore()

const menuShrinkedState = localStorage.getItem('menuShrinked') || 'N'
const shrinked = ref<boolean>(menuShrinkedState === 'Y')
const mobileMenuActive = ref(false)
const currentRouteName = computed(() => route.name as pageNames)

function toggleTextMenubar(): void {
  shrinked.value = !shrinked.value
  localStorage.setItem('menuShrinked', shrinked.value ? 'Y' : 'N')
}
</script>
<template>
  <div
    class="md:hidden flex flex-col items-center w-full bg-white"
    :class="[mobileMenuActive ? 'fixed h-screen z-100 overflow-y-scroll' : '']"
  >
    <div class="md:hidden px-4 py-5 flex flex-row w-full justify-between">
      <div class="logo-menubar h-[44px]" @click="router.push({ name: pageNames.HOME })"></div>
      <button type="button" @click="() => (mobileMenuActive = !mobileMenuActive)">
        <BaseIcon v-if="!mobileMenuActive" :icon-name="iconNames.NAVIGATION" :size="24"/>
        <BaseIcon v-else :icon-name="iconNames.EXIT" :size="24"/>
      </button>
    </div>
    <div class="relative w-full" v-show="mobileMenuActive">
      <BaseMenuBarMobile />
    </div>
  </div>

  <div
    :class="[shrinked ? 'menubar-small' : 'menubar']"
    class="hidden md:block w-full absolute md:relative"
  >
    <div
      :class="[shrinked ? 'px-4' : 'px-6']"
      class="flex py-7-5 h-26 justify-center lg:justify-between padding-logo"
    >
      <div
        :class="[shrinked ? 'logo-menubar-with-text' : 'logo-menubar']"
        @click="router.push({ name: pageNames.HOME })"
      ></div>
      <button @click="toggleTextMenubar()" class="hidden lg:block">
        <div :class="[shrinked ? 'menubar-nav-right' : 'menubar-nav-left']"></div>
      </button>
      <div class="text-right md:hidden">
        <button type="button"></button>
      </div>
    </div>
    <!-- <div class="border-t-[1px] border-slate-300"></div> -->
    <div
      :class="[shrinked ? 'px-9' : 'px-6']"
      class="py-8 border-t border-slate-300 padding-menubar"
    >
      <p
        :class="[shrinked ? 'text-center' : 'text-start']"
        class="text-tertiary font-semibold text-sm text-title-menubar"
      >
        Main
      </p>
      <button
        :class="[
          shrinked ? 'justify-center' : 'justify-start',
          currentRouteName === pageNames.HOME ? 'active' : ''
        ]"
        class="flex w-full mt-4 p-2 text-menubar text-base font-medium rounded-md menubar-list cursor-pointer justify-list-menubar"
        @click="() => router.push({ name: pageNames.HOME })"
      >
        <div
          :class="[
            currentRouteName === pageNames.HOME ? 'menubar-landing-active' : 'menubar-landing'
          ]"
          width="24px"
          height="24px"
        ></div>
        <p :class="[shrinked ? 'hidden' : 'block']" class="pl-3 text-list-menubar">Algo</p>
      </button>
      <button
        :class="[
          shrinked ? 'justify-center' : 'justify-start',
          [
            pageNames.RESEARCH,
            pageNames.RESEARCHEDITOR,
            pageNames.RESEARCHEDITOREXISTING,
            pageNames.RESEARCHEDITORNEW
          ].includes(currentRouteName)
            ? 'active'
            : ''
        ]"
        class="flex w-full mt-4 p-2 text-menubar text-base font-medium rounded-md menubar-list cursor-pointer justify-list-menubar"
        @click="() => router.push({ name: pageNames.RESEARCH })"
      >
        <div
          :class="[
            [
              pageNames.RESEARCH,
              pageNames.RESEARCHEDITOR,
              pageNames.RESEARCHEDITOREXISTING,
              pageNames.RESEARCHEDITORNEW
            ].includes(currentRouteName)
              ? 'menubar-research-active'
              : 'menubar-research'
          ]"
        ></div>
        <p :class="[shrinked ? 'hidden' : 'block']" class="pl-3 text-list-menubar">Content</p>
      </button>
      <button
        v-if="userProfile.getUserProfile.role === 'corporate'"
        :class="[
          shrinked ? 'justify-center' : 'justify-start',
          [
            pageNames.WRITER,
            pageNames.WRITERNEWVIEW,
            pageNames.WRITEREDITORVIEW
          ].includes(currentRouteName)
            ? 'active'
            : ''
        ]"
        class="flex w-full mt-4 p-2 text-menubar text-base font-medium rounded-md menubar-list cursor-pointer justify-list-menubar"
        @click="() => router.push({ name: pageNames.WRITER })"
      >
        <div
          :class="[
            [
              pageNames.WRITER,
              pageNames.WRITERNEWVIEW,
              pageNames.WRITEREDITORVIEW
            ].includes(currentRouteName)
              ? 'menubar-writer-active'
              : 'menubar-writer'
          ]"
        ></div>
        <p :class="[shrinked ? 'hidden' : 'block']" class="pl-3 text-list-menubar">Writer</p>
      </button>
    </div>
  </div>
</template>
